export default import.meta.ROLLDOWN_FILE_URL_6kssa3xCT2YlMpIbbRNP$Q_ddce771825289593dc0e685f